import { useState, useEffect } from 'react';

const useMediumScreen = () => {
  const [isInRange, setIsInRange] = useState(window.innerWidth >= 1000 && window.innerWidth <= 1366);

  useEffect(() => {
    const checkWindowSize = () => {
      const width = window.innerWidth;
      setIsInRange(width >= 1000 && width <= 1366);
    };

    checkWindowSize();
    window.addEventListener('resize', checkWindowSize);

    return () => {
      window.removeEventListener('resize', checkWindowSize);
    };
  }, []);

  return isInRange;
};

export default useMediumScreen;